/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { BillingQuotaDefinition } from './BillingQuotaDefinition';
import {
    BillingQuotaDefinitionFromJSON,
    BillingQuotaDefinitionFromJSONTyped,
    BillingQuotaDefinitionToJSON,
    BillingQuotaDefinitionToJSONTyped,
} from './BillingQuotaDefinition';

/**
 * 
 * @export
 * @interface ListBillingQuotaDefinitionsResponse
 */
export interface ListBillingQuotaDefinitionsResponse {
    /**
     * 
     * @type {Array<BillingQuotaDefinition>}
     * @memberof ListBillingQuotaDefinitionsResponse
     */
    data: Array<BillingQuotaDefinition>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBillingQuotaDefinitionsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBillingQuotaDefinitionsResponse interface.
 */
export function instanceOfListBillingQuotaDefinitionsResponse(value: object): value is ListBillingQuotaDefinitionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBillingQuotaDefinitionsResponseFromJSON(json: any): ListBillingQuotaDefinitionsResponse {
    return ListBillingQuotaDefinitionsResponseFromJSONTyped(json, false);
}

export function ListBillingQuotaDefinitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillingQuotaDefinitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BillingQuotaDefinitionFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBillingQuotaDefinitionsResponseToJSON(json: any): ListBillingQuotaDefinitionsResponse {
      return ListBillingQuotaDefinitionsResponseToJSONTyped(json, false);
  }

  export function ListBillingQuotaDefinitionsResponseToJSONTyped(value?: ListBillingQuotaDefinitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BillingQuotaDefinitionToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

